var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.76105 10C4.43275 10 4.10445 9.86916 3.85383 9.60594L0.37593 5.95321C-0.12531 5.42677 -0.12531 4.574 0.37593 4.0491C0.87717 3.52267 1.68765 3.52113 2.1889 4.04756L4.76105 6.74902L10.8111 0.394828C11.3123 -0.131609 12.1228 -0.131609 12.6241 0.394828C13.1253 0.921265 13.1253 1.77403 12.6241 2.30047L5.66826 9.60594C5.41764 9.86916 5.08935 10 4.76105 10Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.f8f2196b1c63384216f325b74238569f.svg";
export { ForwardRef as ReactComponent };